export default {
    cn: {
        realTimeReport: {
            detail: '实时佣金明细',
            text: '实时佣金结果',
            typeText: '佣金类别：',
            IB_ID: '代理账号：',
            clientAccount: '客户账号：',
            mtlogin: 'MT交易账号：',
            depositAccount: '入金账号：',
            symbol: '交易品种：',
            trade_order_id: '交易单号：',
            deposit_order_id: '佣金单号：',
            start_time: '开始时间：',
            end_time: '结束时间：',
            search: '搜索',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            downloadDetailExcel: "下载明细",
            downloadFilterExcel: '下载明细(指定账号)',
            nodata: "没有查询到数据",
            selectTimeText: '选择日期',
            moreSelect: '显示更多筛选',
            return: '返回',
            sheetName: ['代理佣金', '下层返佣'],
            downloadName: '实时佣金明细',
            filterName: '实时佣金明细(指定账号)',
            total: { total: "合计", part: "part", index: 1 },
            typeList: { "-1": '全部', "0": '代理佣金', "1": "下层返佣" },
            detailType: { "0": "买入", "1": "卖出" },
            errorMsg: '请填入正确的客户账号或者MT交易账号',
            detailTh: [
                { key: 'trade_order_id', name: '交易单号' },
                { key: 'IB_ID', name: '代理账号', flag: true },
                { key: 'CLIENT_ID', name: '客户账号' },
                { key: 'USER_GROUP', name: '组别' },
                { key: 'SYMBOL', name: '交易品种' },
                { key: 'type', name: '类型' },
                { key: 'VOLUME', name: '交易量' },
                { key: 'OPEN_TIME', name: '开仓时间' },
                { key: 'CLOSE_TIME', name: '平仓时间' },
                // { key: 'EXTERNAL_COMMISSION_REBATE', name: '外佣每手佣金' },
                { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: '外佣金额' },
                { key: 'SPREAD_REBATE', name: '加点每手佣金' },
                { key: 'SPREAD_COMMISSION_AFTER_RULE', name: '加点金额' },
                { key: 'INTERNAL_COMMISSION_REBATE', name: '内佣每手佣金' },
                { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: '内佣金额' },
                { key: 'TOTAL_COMMISSION', name: '总金额' },
            ],
            detailTh_v2: [
                { key: 'trade_order_id', name: '交易单号' },
                { key: 'IB_ID', name: '代理账号', flag: true },
                { key: 'CLIENT_ID', name: '客户账号' },
                { key: 'PLATFORM', name: '交易平台' },
                { key: 'TRADING_ACCOUNT_ID', name: '交易账号' },
                { key: 'USER_GROUP', name: '组别' },
                { key: 'SYMBOL', name: '交易品种' },
                { key: 'type', name: '类型' },
                { key: 'VOLUME', name: '交易量' },
                { key: 'OPEN_TIME', name: '开仓时间' },
                { key: 'CLOSE_TIME', name: '平仓时间' },
                // { key: 'EXTERNAL_COMMISSION_REBATE', name: '外佣每手佣金' },
                { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: '外佣金额' },
                { key: 'SPREAD_REBATE', name: '加点每手佣金' },
                { key: 'SPREAD_COMMISSION_AFTER_RULE', name: '加点金额' },
                { key: 'INTERNAL_COMMISSION_REBATE', name: '内佣每手佣金' },
                { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: '内佣金额' },
                { key: 'TOTAL_COMMISSION', name: '总金额' },
            ],
            extraHead: [
                { key: 'F_IB_ID', name: '代理账号' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: '入金账号' }
            ],
            lowerLevel: [
                { key: 'ib_id', name: '下层代理账号' },
                { key: 'SUB_DEPOSIT_ACCOUNT', name: '下层代理入金账号' },
                { key: 'NAME', name: '代理姓名' },
                { key: 'rule_id', name: '规则' },
                { key: 'VALUE', name: '规则参数' },
                { key: 'product_group', name: '产品' },
                { key: 'TOTAL_VOLUME', name: '总手数' },
                { key: 'EXTERNAL_COMMISSION', name: '外佣金额' },
                { key: 'SPREAD_COMMISSION', name: '加点金额' },
                { key: 'INTERNAL_COMMISSION', name: '内佣金额' },
                { key: 'RULE_COMMISSION', name: '总金额' },
            ],
            realTimeTh: [
                { key: 'type', name: '佣金类别' },
                { key: 'REPORT_ID', name: '单号', flag: false },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' },
                { key: 'IB_ID', name: '代理账号' },
                { key: 'NAME', name: '代理名称' },
                { key: 'AMOUNT', name: '金额' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'BEGINTIME', name: '开始时间' },
                { key: 'ENDTIME', name: '结束时间' }
            ],
            realTimeTh_v2: [
                { key: 'type', name: '佣金类别' },
                { key: 'REPORT_ID', name: '单号', flag: false },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' },
                { key: 'IB_ID', name: '代理账号' },
                { key: 'NAME', name: '代理名称' },
                { key: 'DEPOSIT_PLATFORM', name: '交易平台' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: '入金账号' },
                { key: 'AMOUNT', name: '金额' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'BEGINTIME', name: '开始时间' },
                { key: 'ENDTIME', name: '结束时间' }
            ]
        }
    },
    hk: {
        realTimeReport: {
            detail: '實時佣金明細',
            text: '實時佣金結果',
            typeText: '佣金類別：',
            IB_ID: '代理賬號：',
            clientAccount: '客戶賬號：',
            mtlogin: 'MT交易賬號：',
            depositAccount: '入金賬號：',
            symbol: '交易品種：',
            trade_order_id: '交易單號：',
            deposit_order_id: '佣金單號：',
            start_time: '開始時間：',
            end_time: '結束時間：',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            downloadDetailExcel: "下載明細",
            downloadFilterExcel: '下載明細(指定賬號)',
            search: "搜索",
            nodata: "没有查询到数据",
            selectTimeText: '選擇日期',
            moreSelect: '顯示更多篩選',
            return: '返回',
            sheetName: ['代理佣金', '下層返佣'],
            downloadName: '實時佣金明細',
            filterName: '實時佣金明細(指定賬號)',
            total: { total: "合計", part: "part", index: 1 },
            typeList: { "-1": '全部', "0": '代理佣金', "1": "下層返佣" },
            detailType: { "0": "買入", "1": "賣出" },
            errorMsg: '請填入正確的客戶賬號或者MT交易賬號',
            detailTh: [
                { key: 'trade_order_id', name: '交易單號' },
                { key: 'IB_ID', name: '代理賬號', flag: true },
                { key: 'CLIENT_ID', name: '客戶賬號' },
                { key: 'USER_GROUP', name: '組別' },
                { key: 'SYMBOL', name: '交易品種' },
                { key: 'type', name: '類型' },
                { key: 'VOLUME', name: '交易量' },
                { key: 'OPEN_TIME', name: '開倉時間' },
                { key: 'CLOSE_TIME', name: '平倉時間' },
                // { key: 'EXTERNAL_COMMISSION_REBATE', name: '外佣每手佣金' },
                { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: '外佣金額' },
                { key: 'SPREAD_REBATE', name: '加點每手佣金' },
                { key: 'SPREAD_COMMISSION_AFTER_RULE', name: '加點金額' },
                { key: 'INTERNAL_COMMISSION_REBATE', name: '內佣每手佣金' },
                { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: '內佣金額' },
                { key: 'TOTAL_COMMISSION', name: '總金額' },
            ],
            detailTh_v2: [
                { key: 'trade_order_id', name: '交易單號' },
                { key: 'IB_ID', name: '代理賬號', flag: true },
                { key: 'CLIENT_ID', name: '客戶賬號' },
                { key: 'PLATFORM', name: '交易平台' },
                { key: 'TRADING_ACCOUNT_ID', name: '交易賬號' },
                { key: 'USER_GROUP', name: '組別' },
                { key: 'SYMBOL', name: '交易品種' },
                { key: 'type', name: '類型' },
                { key: 'VOLUME', name: '交易量' },
                { key: 'OPEN_TIME', name: '開倉時間' },
                { key: 'CLOSE_TIME', name: '平倉時間' },
                // { key: 'EXTERNAL_COMMISSION_REBATE', name: '外佣每手佣金' },
                { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: '外佣金額' },
                { key: 'SPREAD_REBATE', name: '加點每手佣金' },
                { key: 'SPREAD_COMMISSION_AFTER_RULE', name: '加點金額' },
                { key: 'INTERNAL_COMMISSION_REBATE', name: '內佣每手佣金' },
                { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: '內佣金額' },
                { key: 'TOTAL_COMMISSION', name: '總金額' },
            ],
            extraHead: [
                { key: 'F_IB_ID', name: '代理賬號' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' },
                { key: 'DEPOSIT_COMMENT', name: '佣金註解' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: '入金賬號' }
            ],
            lowerLevel: [
                { key: 'ib_id', name: '下層代理賬號' },
                { key: 'SUB_DEPOSIT_ACCOUNT', name: '下層代理入金賬號' },
                { key: 'NAME', name: '代理姓名' },
                { key: 'rule_id', name: '規則' },
                { key: 'VALUE', name: '規則參數' },
                { key: 'product_group', name: '產品' },
                { key: 'TOTAL_VOLUME', name: '總手數' },
                { key: 'EXTERNAL_COMMISSION', name: '外佣金額' },
                { key: 'SPREAD_COMMISSION', name: '加點金額' },
                { key: 'INTERNAL_COMMISSION', name: '內佣金額' },
                { key: 'RULE_COMMISSION', name: '總金額' },
            ],
            realTimeTh: [
                { key: 'type', name: '佣金類別' },
                { key: 'REPORT_ID', name: '單號', flag: false },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' },
                { key: 'IB_ID', name: '代理賬號' },
                { key: 'NAME', name: '代理名稱' },
                { key: 'AMOUNT', name: '金額' },
                { key: 'DEPOSIT_COMMENT', name: '佣金註解' },
                { key: 'BEGINTIME', name: '開始時間' },
                { key: 'ENDTIME', name: '結束時間' }
            ],
            realTimeTh_v2: [
                { key: 'type', name: '佣金類別' },
                { key: 'REPORT_ID', name: '單號', flag: false },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' },
                { key: 'IB_ID', name: '代理賬號' },
                { key: 'NAME', name: '代理名稱' },
                { key: 'DEPOSIT_PLATFORM', name: '交易平台' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: '入金賬號' },
                { key: 'AMOUNT', name: '金額' },
                { key: 'DEPOSIT_COMMENT', name: '佣金註解' },
                { key: 'BEGINTIME', name: '開始時間' },
                { key: 'ENDTIME', name: '結束時間' }
            ]
        }
    },
    en: {
        realTimeReport: {
            detail: 'Real Time Result Detail',
            text: 'Real Time Result',
            typeText: 'Type：',
            IB_ID: 'Account：',
            clientAccount: 'Client Account：',
            mtlogin: 'Trading Account：',
            depositAccount: 'Deposit Account：',
            symbol: 'Symbol：',
            trade_order_id: 'Trade Order ID：',
            deposit_order_id: 'Order ID：',
            start_time: 'Start Time：',
            end_time: 'End Time：',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            downloadDetailExcel: "Download Detail",
            downloadFilterExcel: "Download Detail(Assign Account)",
            nodata: "No data found",
            selectTimeText: 'Select Date',
            moreSelect: 'Show More Select',
            return: 'Go Back',
            sheetName: ['IB Commission', 'Lower Level Commission'],
            downloadName: 'Realtime Result Detail',
            filterName: 'Realtime Result Detail(Assign Account)',
            total: { total: "TOTAL", part: "part", index: 1 },
            typeList: { "-1": 'All', "0": 'IB Commission', "1": "Lower Level Commission" },
            detailType: { "0": "BUY", "1": "SELL" },
            errorMsg: 'Please fill in the correct client account or MT trading account',
            detailTh: [
                { key: 'trade_order_id', name: 'Order ID' },
                { key: 'IB_ID', name: 'IB Account', flag: true },
                { key: 'CLIENT_ID', name: 'Customer Account' },
                { key: 'USER_GROUP', name: 'Group' },
                { key: 'SYMBOL', name: 'Symbol' },
                { key: 'type', name: 'Type' },
                { key: 'VOLUME', name: 'Volume' },
                { key: 'OPEN_TIME', name: 'Open Time' },
                { key: 'CLOSE_TIME', name: 'Close Time' },
                { key: 'EXTERNAL_COMMISSION_REBATE', name: 'External Commission Rebate' },
                { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: 'External Commission After Rule' },
                { key: 'SPREAD_REBATE', name: 'Spread Rebate' },
                { key: 'SPREAD_COMMISSION_AFTER_RULE', name: 'Spread Commission After Rule' },
                { key: 'INTERNAL_COMMISSION_REBATE', name: 'Internal Commission Rebate' },
                { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: 'Internal Commission After Rule' },
                { key: 'TOTAL_COMMISSION', name: 'Total Commission' },
            ],
            detailTh_v2: [
                { key: 'trade_order_id', name: 'Order ID' },
                { key: 'IB_ID', name: 'IB Account', flag: true },
                { key: 'CLIENT_ID', name: 'Client Account' },
                { key: 'PLATFORM', name: 'Trade Platform' },
                { key: 'TRADING_ACCOUNT_ID', name: 'Trading Account' },
                { key: 'USER_GROUP', name: 'Group' },
                { key: 'SYMBOL', name: 'Symbol' },
                { key: 'type', name: 'Type' },
                { key: 'VOLUME', name: 'Volume' },
                { key: 'OPEN_TIME', name: 'Open Time' },
                { key: 'CLOSE_TIME', name: 'Close Time' },
                { key: 'EXTERNAL_COMMISSION_REBATE', name: 'External Commission Rebate' },
                { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: 'External Commission After Rule' },
                { key: 'SPREAD_REBATE', name: 'Spread Rebate' },
                { key: 'SPREAD_COMMISSION_AFTER_RULE', name: 'Spread Commission After Rule' },
                { key: 'INTERNAL_COMMISSION_REBATE', name: 'Internal Commission Rebate' },
                { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: 'Internal Commission After Rule' },
                { key: 'TOTAL_COMMISSION', name: 'Total Commission' },
            ],
            extraHead: [
                { key: 'F_IB_ID', name: 'IB Account' },
                { key: 'DEPOSIT_ORDER_ID', name: 'Deposit Order ID' },
                { key: 'DEPOSIT_COMMENT', name: 'Comment' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: 'Deposit Account ID' }
            ],
            lowerLevel: [
                { key: 'ib_id', name: 'Lower IB Account' },
                { key: 'SUB_DEPOSIT_ACCOUNT', name: 'Lower IB Deposit Account' },
                { key: 'NAME', name: 'IB Name' },
                { key: 'rule_id', name: 'Rule' },
                { key: 'VALUE', name: 'Rule Parameter' },
                { key: 'product_group', name: 'Product Group' },
                { key: 'TOTAL_VOLUME', name: 'Total Volume' },
                { key: 'EXTERNAL_COMMISSION', name: 'External Commission' },
                { key: 'SPREAD_COMMISSION', name: 'Spread Commission' },
                { key: 'INTERNAL_COMMISSION', name: 'Internal Commission' },
                { key: 'RULE_COMMISSION', name: 'Rule Commission' },
            ],
            realTimeTh: [
                { key: 'type', name: 'Commission Type' },
                { key: 'REPORT_ID', name: 'Record ID', flag: false },
                { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' },
                { key: 'IB_ID', name: 'IB Account' },
                { key: 'NAME', name: 'IB Name' },
                { key: 'AMOUNT', name: 'Amount' },
                { key: 'DEPOSIT_COMMENT', name: 'Comment' },
                { key: 'BEGINTIME', name: 'Begin Time' },
                { key: 'ENDTIME', name: 'End Time' }
            ],
            realTimeTh_v2: [
                { key: 'type', name: 'Commission Type' },
                { key: 'REPORT_ID', name: 'Record ID', flag: false },
                { key: 'DEPOSIT_ORDER_ID', name: 'Deposit Order ID' },
                { key: 'IB_ID', name: 'IB Account' },
                { key: 'NAME', name: 'IB Name' },
                { key: 'DEPOSIT_PLATFORM', name: 'Trade Platform' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: 'Deposit Account' },
                { key: 'AMOUNT', name: 'Amount' },
                { key: 'DEPOSIT_COMMENT', name: 'Comment' },
                { key: 'BEGINTIME', name: 'Begin Time' },
                { key: 'ENDTIME', name: 'End Time' }
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/realTimeReport.js